<template>
    <div class="account">
        <el-breadcrumb separator-class="el-icon-arrow-right" v-if="postList.headerTitle">
            <el-breadcrumb-item>人员绩效审批</el-breadcrumb-item>
        </el-breadcrumb>
        <el-row class="main_header">
            <div class="main_header_item">
                <el-input v-model="queryParams.id" placeholder="请输入ID" clearable @keyup.enter.native="getList(1)"></el-input>
            </div>
            <div class="main_header_item" v-show="postList.person_performance_id">
                <el-input
                    v-model="queryParams.person_performance_id"
                    placeholder="请输入人员绩效ID"
                    clearable
                    @keyup.enter.native="getList(1)"
                ></el-input>
            </div>
            <div class="main_header_item">
                <vDropdown
                    model_key="person_code"
                    model_name="请选择人员"
                    :model_value_default="queryParams['person_code']"
                    select_value="code"
                    request_uri="dropdownPerson"
                    @onDropChange="onDropChange"
                    ref="person_code_ref"
                ></vDropdown>
            </div>
            <div class="main_header_item">
                <el-input
                    v-model="queryParams.period_code"
                    placeholder="请输入期间编码"
                    clearable
                    @keyup.enter.native="getList(1)"
                ></el-input>
            </div>
            <div class="main_header_item">
                <el-date-picker
                    v-model="queryParams['date_range']"
                    type="daterange"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd"
                    size="small"
                    style="width: 300px"
                >
                </el-date-picker>
            </div>
            <div class="main_header_item">
                <el-input v-model="queryParams.remark" placeholder="请输入备注" clearable @keyup.enter.native="getList(1)"></el-input>
            </div>
        </el-row>
        <div class="main_list">
            <div class="flex">
                <el-button size="small" plain @click="insert" icon="el-icon-plus" :loading="btnLoading">新增</el-button>
                <el-button size="small" plain @click="recalculate()" :loading="btnLoading">重算</el-button>
                <el-button size="small" plain @click="show_help()" icon="el-icon-question">帮助信息</el-button>

                <div class="main_header_btns">
                    <el-button type="primary" size="small" @click="getList(1)">搜索</el-button>
                    <el-button size="small" type="primary" plain @click="reset">重置</el-button>
                    <el-button size="small" plain icon="el-icon-bottom" @click="getList(2)" :loading="down_loading">下载</el-button>
                    <crm-upload obj="person_performance_confirm" :queryParams="queryParams"></crm-upload>
                    <draggableList :draggable="draggable" @isErrShow="onSetFieldDone"></draggableList>
                </div>
            </div>

            <div v-show="is_show_help">
                <div class="flex">
                    <span style="color: red; font-size: 13px"> 重算按钮与人员绩效列表相同 </span>
                </div>
                <div class="flex">
                    <span style="color: red; font-size: 13px">
                        新增人员绩效审批前，须先创建人员绩效(可通过重算按钮初始化已存在绩效人员的维度)
                    </span>
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                ref="tableDataRef"
                :max-height="this.$tableHeight"
                class="person_performance_confirm"
                @header-dragend="changeColWidth"
                v-loading="loading"
                element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255, 255, 0.8)"
                style="width: 100%"
            >
                <template v-for="(item, index) in colData">
                    <el-table-column
                        :key="index"
                        :prop="item.prop"
                        :label="item.title"
                        :min-width="item.width"
                        :sortable="item.sort"
                        align="left"
                        show-overflow-tooltip
                        v-if="colData[index].is_show"
                    >
                        <template slot-scope="scope">
                            <div v-if="in_array(item.prop, ['person_name', 'id', 'person_performance_id'])">
                                <el-link type="primary" @click="toDetail(scope.row, item.prop)" style="font-size: 11px"
                                    >{{ scope.row[item.prop] }}
                                </el-link>
                            </div>
                            <div v-else>
                                <span> {{ scope.row[item.prop] }} </span>
                            </div>
                        </template>
                    </el-table-column>
                </template>
                <el-table-column label="操作" width="80" fixed="right">
                    <template slot-scope="scope">
                        <el-tooltip class="item" effect="dark" content="复制" placement="top-start">
                            <i class="el-icon-menu" @click="copy(scope.row.id)"></i>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="编辑" placement="top-start">
                            <i class="el-icon-s-claim" @click="update(scope.row.id)"></i>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="删除" placement="top-start">
                            <i class="el-icon-delete-solid" @click="del(scope.row)"></i>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total,prev, pager, next, sizes, jumper"
                    @current-change="currentChange"
                    @size-change="sizeChange"
                    :page-sizes="[10, 25, 50, 75, 100]"
                    :current-page="queryParams.page"
                    :page-size="queryParams.row"
                    :total="total"
                ></el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
import { onDelete, onReSize, onSearch, in_array } from '@/js/common.js';
import draggableList from '@/components/common/Drawer.vue';
import vSearchSelect from '@/components/common/dropdown/search.vue';
import crmUpload from '@/components/common/Upload.vue';

export default {
    inject: ['reload'],
    //注册draggable组件
    components: {
        draggableList,
        vSearchSelect,
        crmUpload
    },
    name: 'personPerformanceConfirmComponent',
    data() {
        return {
            is_show_help: false,
            draggable: {
                data_name: 'person_performance_confirm'
            },
            down_loading: false,
            btnLoading: false,
            loading: true,
            tableData: [],
            colData: [],
            total: 0,
            // sort: '', //排序参数
            // data_name: '', //排序参数
            queryParams: {}
        };
    },
    props: {
        postList: {
            type: Object
        }
    },
    beforeMount() {
        this.recoveryQueryParams('page');
    },
    mounted() {
        this.$nextTick(() => {
            this.selectedColData(); //筛选列
            this.recoveryQueryParams();
            if (this.postList.params) {
                if (this.postList.params.person_performance_id) {
                    this.queryParams.person_performance_id = this.postList.params.person_performance_id;
                }
                this.queryParams.row = 10;
                this.getList(0);
            } else {
                this.getList(0); //获取列表
            }
        });
    },
    methods: {
        in_array,
        show_help() {
            this.is_show_help = this.is_show_help == false ? true : false;
        },
        //跳转详情
        toDetail(row, prop) {
            if (in_array(prop, ['person_name']) && row.person_rid) {
                this.$router.push({
                    path: '/personDetail',
                    query: {
                        id: row.person_rid
                    }
                });
            } else if (in_array(prop, ['id']) && row.id) {
                this.$router.push({
                    path: '/personPerformanceConfirmDetail',
                    query: {
                        id: row.id
                    }
                });
            } else if (in_array(prop, ['person_performance_id']) && row.person_performance_id) {
                this.$router.push({
                    path: '/personPerformanceDetail',
                    query: {
                        id: row.person_performance_id
                    }
                });
            }
        },
        initQueryParams() {
            this.queryParams = {
                page: 1,
                row: 25,
                is_export: 0,
                person_performance_id:
                    this.postList.params && this.postList.params.person_performance_id ? this.postList.params.person_performance_id : ''
            };

            this.saveQueryParams();
        },
        onDropChange(key, value) {
            this.queryParams[key] = value;
        },
        saveQueryParams() {
            if (!this.postList.params) {
                localStorage.setItem('person_performance_confirm_params', JSON.stringify(this.queryParams));
            }
        },
        // 分页参数需要在beforeMount初始化，先兼容下
        recoveryQueryParams(type = 'common') {
            //详情内调用不用本地存储的params
            if (!this.postList.params) {
                //列表页面调用 优先取本地存储
                const queryParams = JSON.parse(localStorage.getItem('person_performance_confirm_params'));
                if (queryParams) {
                    if (type == 'common') {
                        this.queryParams = queryParams;
                    } else {
                        this.queryParams.page = queryParams.page || 1;
                        this.queryParams.row = queryParams.row || 25;
                    }
                } else {
                    this.initQueryParams();
                }
            }
        },
        //子组件更新完毕
        onSetFieldDone(data) {
            //刷新下页面
            this.reload();
        },
        //列宽改变事件
        changeColWidth(nw, ow, col, evt) {
            onReSize('person_performance_confirm', this);
        },
        //筛选列
        selectedColData() {
            this.colData = JSON.parse(localStorage.getItem('dataList')).person_performance_confirm;
        },
        // 获取列表 0-非搜索 1-搜索 2-下载
        getList(search_type = 0) {
            onSearch(search_type, this, 'personPerformanceConfirmLists');
        },
        //新增
        insert() {
            this.$router.push({
                path: 'personPerformanceConfirmEdit',
                query: {
                    type: 'insert',
                    person_performance_id:
                        this.postList.params && this.postList.params.person_performance_id ? this.postList.params.person_performance_id : ''
                }
            });
        },
        //删除
        del(row) {
            onDelete(row.id, this, 'personPerformanceConfirmDelete', row.id);
        },
        //编辑
        update(id) {
            this.$router.push({
                path: 'personPerformanceConfirmEdit',
                query: {
                    type: 'update',
                    id: id
                }
            });
        },
        //复制
        copy(id) {
            this.$router.push({
                path: 'personPerformanceConfirmEdit',
                query: {
                    type: 'copy',
                    id: id
                }
            });
        },
        currentChange(page) {
            this.queryParams.page = page;
            this.saveQueryParams();
            this.getList(0);
        },
        sizeChange(row) {
            this.queryParams.row = row;
            this.saveQueryParams();
            this.getList(0);
        },
        reset() {
            this.initQueryParams();
            this.$refs.person_code_ref.reset();
            this.getList();
        },
        // 重算绩效
        recalculate() {
            this.$confirm('您确定要进行重算吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                closeOnPressEscape: false,
                closeOnClickModal: false
            })
                .then(() => {
                    this.btnLoading = true;
                    this.$api['personPerformanceRecalculate']({})
                        .then((res) => {
                            if (res.code == 0) {
                                this.$message({
                                    message: '操作成功',
                                    type: 'success'
                                });
                                this.reload();
                            }
                            this.btnLoading = false;
                        })
                        .catch((error) => {
                            this.btnLoading = false;
                        });
                })
                .catch(() => {});
        }
    }
};
</script>
<style lang="scss" scoped>
/deep/ .el-table__empty-block {
    width: 100% !important;
    min-width: 100% !important;
    max-width: 100% !important;
    padding-right: 100% !important;
}
</style>